import { render, staticRenderFns } from "./Alum.vue?vue&type=template&id=14d9398f&scoped=true&"
import script from "./Alum.vue?vue&type=script&lang=ts&"
export * from "./Alum.vue?vue&type=script&lang=ts&"
import style0 from "./Alum.vue?vue&type=style&index=0&id=14d9398f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d9398f",
  null
  
)

export default component.exports